import { Pipe, PipeTransform } from '@angular/core';

// INTERFACES
import { ICreditCard } from '../../../client/interfaces/client-payment-profile.interface';

// SERVICES
import { CardUtilService } from '../../services/util/card-util.service';

@Pipe({
  name: 'formatCardExpiry',
})
export class FormatCardExpiryPipe implements PipeTransform {
  constructor(private cardUtilService :CardUtilService) {}

  transform(card :ICreditCard) :string {
    return this.cardUtilService.getExpirationDateFormat(card);
  }
}
